<div class="event-expenses p-3">

    <div class="rana-page-header">
        <div>
            <h1 class="rana-page-title" style="font-size:20px;">Expenses</h1>
            <p class="rana-page-subtitle" *ngIf="expenses.length">{{ expenses.length }} line item{{ expenses.length === 1 ? '' : 's' }} logged</p>
        </div>
    </div>

    <div class="rana-kpi-row">
        <div class="rana-kpi-card">
            <div class="rana-kpi-icon success">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 1v22"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
            </div>
            <div class="rana-kpi-value" style="font-size:22px;">{{ totalCollection | currency }}</div>
            <div class="rana-kpi-label">Total Collection</div>
            <div class="small text-muted mt-1">
                Adults: {{ adultCount }} &times; {{ adultFee | currency }}<br>
                Children: {{ childCount }} &times; {{ childFee | currency }}<br>
                <span *ngIf="seniorCount > 0">Senior Citizens: {{ seniorCount }} &times; {{ seniorFee | currency }}<br></span>
                <span *ngIf="donationTotal && donationTotal > 0"><br>Donations: {{ donationTotal | currency }}</span>
            </div>
        </div>
        <div class="rana-kpi-card">
            <div class="rana-kpi-icon accent">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="6" width="20" height="14" rx="2"/><path d="M2 10h20"/></svg>
            </div>
            <div class="rana-kpi-value" style="font-size:22px;">{{ totalExpenses | currency }}</div>
            <div class="rana-kpi-label">Total Expenses</div>
        </div>
        <div class="rana-kpi-card">
            <div class="rana-kpi-icon" [ngClass]="isProfit ? 'success' : 'accent'">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline [attr.points]="isProfit ? '3 17 9 11 13 15 21 6' : '3 6 9 15 13 11 21 20'"/></svg>
            </div>
            <div class="rana-kpi-value" style="font-size:22px;" [style.color]="isProfit ? 'var(--rana-success)' : 'var(--rana-danger)'">{{ netBalance | currency }}</div>
            <div class="rana-kpi-label">{{ isProfit ? 'Profit' : 'Loss' }}</div>
        </div>
    </div>

    <!-- Add Expense -->
    <div class="rounded mb-3 expense-add-card" *ngIf="status != 'CLOSED'">
        <div class="expense-add-header">
            <i class="uil uil-receipt-alt mr-2"></i>Add Event Expense
        </div>
        <div class="expense-add-body">

        <div class="form-row">
            <div class="form-group col-sm-8 mb-2">
                <label class="nfr-label">Category</label>
                <input type="text" class="form-control form-control-sm nfr-input-control"
                       placeholder="e.g. Venue, Catering, Printing"
                       [(ngModel)]="newExpense.category"/>
            </div>
            <div class="form-group col-sm-4 mb-2">
                <label class="nfr-label">Amount</label>
                <div class="input-group input-group-sm amount-input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">$</span>
                    </div>
                    <input type="number" min="0" step="0.01"
                           class="form-control nfr-input-control" placeholder="0.00"
                           [(ngModel)]="newExpense.amount"/>
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-12 mb-2">
                <label class="nfr-label">Spent By</label>
                <select class="form-control form-control-sm nfr-input-control" [(ngModel)]="newExpense.spentBy">
                    <option value="">Select member</option>
                    <option *ngFor="let m of expenseMembers" [value]="m.id">{{ m.label }}</option>
                </select>
            </div>
        </div>

        <div class="form-group mb-2">
            <label class="nfr-label">Receipt <span class="text-muted font-weight-normal">(optional)</span></label>
            <input id="expenseReceiptInput" type="file" class="d-none"
                   accept=".pdf,.jpg,.jpeg,.png" (change)="onReceiptSelected($event)"/>

            <label *ngIf="!selectedReceiptFile" for="expenseReceiptInput" class="receipt-dropzone mb-0">
                <i class="uil uil-cloud-upload"></i>
                <span><strong>Choose a file</strong> to attach &mdash; PDF, JPG, PNG &middot; max 10&nbsp;MB</span>
            </label>

            <div *ngIf="selectedReceiptFile" class="receipt-dropzone has-file">
                <img *ngIf="selectedReceiptPreviewUrl" [src]="selectedReceiptPreviewUrl"
                     alt="Selected receipt preview" class="receipt-thumb receipt-thumb-selected"/>
                <span class="receipt-pdf-chip" *ngIf="!selectedReceiptPreviewUrl"><i class="uil uil-file-alt"></i> PDF</span>
                <span class="receipt-filename text-truncate">{{ selectedReceiptFile.name }}</span>
                <button type="button" class="btn btn-sm btn-link text-danger p-0 ml-auto"
                        title="Remove file" (click)="clearSelectedReceipt()">
                    <i class="uil uil-times-circle size-20"></i>
                </button>
            </div>
        </div>

        <div class="d-flex flex-wrap align-items-center expense-actions mt-1">
            <small class="text-muted mr-auto" *ngIf="!selectedReceiptFile">
                Attaching a receipt lets you add the line item straight from it.
            </small>
            <button class="btn btn-sm nfr-btn btn-outline-secondary mr-2"
                    *ngIf="selectedReceiptFile || uploadingReceipt"
                    [disabled]="uploadingReceipt || !selectedReceiptFile || hasOpenDraft()"
                    (click)="uploadReceiptAndCreateLine()">
                <i class="uil uil-file-upload-alt mr-1"></i>{{ uploadingReceipt ? 'Uploading…' : 'Upload Receipt' }}
            </button>
            <button class="btn btn-sm nfr-btn btn-success" (click)="addExpense()" [disabled]="hasOpenDraft()">
                <i class="uil uil-plus-circle mr-1"></i>Add Expense
            </button>
        </div>

        <small class="text-warning d-block mt-2" *ngIf="hasOpenDraft()">
            <i class="uil uil-exclamation-triangle mr-1"></i>Save or cancel the draft line item first.
        </small>
        <div class="text-muted small mt-1" *ngIf="loading">Loading…</div>
        </div>
    </div>

    <!-- Expenses Table -->
    <div class="rana-table-flat">
    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table rana-table">
        <thead>
        <tr>
            <th>Category</th>
            <th class="text-end">Amount</th>
            <th>Spent By</th>
            <th>Added By</th>
            <th>Added Date</th>
            <th>Receipt</th>
            <th class="text-center">Actions</th>
        </tr>
        </thead>
        <tbody></tbody>
        <tfoot *ngIf="expenses && expenses.length > 0">
        <tr>
            <td><strong>Total</strong></td>
            <td class="text-end"><strong>{{ totalExpenses | currency }}</strong></td>
            <td colspan="5"></td>
        </tr>
        </tfoot>
    </table>
    </div>

    <ng-template #catTpl let-row="adtData"><span class="d-inline-block">
        <span *ngIf="selectedExpense?.expenseId !== row.expenseId">{{ row.category }}</span>
        <input *ngIf="selectedExpense?.expenseId === row.expenseId"
               class="form-control form-control-sm nfr-input-control"
               [ngModel]="selectedExpense?.category" (ngModelChange)="selectedExpense!.category = $event"/>
    </span></ng-template>

    <ng-template #amountTpl let-row="adtData"><span class="d-inline-block">
        <span *ngIf="selectedExpense?.expenseId !== row.expenseId">{{ row.amount | currency }}</span>
        <input *ngIf="selectedExpense?.expenseId === row.expenseId" type="number"
               class="form-control form-control-sm nfr-input-control"
               [ngModel]="selectedExpense?.amount" (ngModelChange)="selectedExpense!.amount = $event"/>
    </span></ng-template>

    <ng-template #spentByTpl let-row="adtData"><span class="d-inline-block">
        <span *ngIf="selectedExpense?.expenseId !== row.expenseId">{{ getMemberName(row.spentBy) }}
            <small class="d-block text-muted" *ngIf="getMemberEmail(row.spentBy)">{{ getMemberEmail(row.spentBy) }}</small></span>
        <select *ngIf="selectedExpense?.expenseId === row.expenseId"
                class="form-control form-control-sm nfr-input-control"
                [ngModel]="selectedExpense?.spentBy" (ngModelChange)="selectedExpense!.spentBy = $event">
            <option value="">Select member</option>
            <option *ngFor="let m of expenseMembers" [value]="m.id">{{ m.label }}</option>
        </select>
    </span></ng-template>

    <ng-template #addedByTpl let-row="adtData"><span class="d-inline-block">
        <ng-container *ngIf="selectedExpense?.expenseId !== row.expenseId">{{ row.addedBy }}</ng-container>
        <ng-container *ngIf="selectedExpense?.expenseId === row.expenseId">{{ selectedExpense?.addedBy || row.addedBy || '--' }}</ng-container>
    </span></ng-template>

    <ng-template #addedDateTpl let-row="adtData"><span class="d-inline-block">
        {{ getDisplayDate(row) }}
    </span></ng-template>

    <ng-template #receiptTpl let-row="adtData"><span class="d-inline-block">
        <ng-container *ngIf="selectedExpense?.expenseId !== row.expenseId">
            <ng-container *ngIf="row.receiptFileName; else noReceiptInRow">
                <img
                        *ngIf="isImageReceipt(row.receiptFileName, row.receiptContentType) && getReceiptThumbnailUrl(row)"
                        [src]="getReceiptThumbnailUrl(row)!"
                        alt="Receipt thumbnail"
                        class="receipt-thumb"
                        title="Open receipt"
                        (click)="viewReceipt(row)"
                />
                <button
                        *ngIf="!isImageReceipt(row.receiptFileName, row.receiptContentType) || !getReceiptThumbnailUrl(row)"
                        type="button"
                        class="btn btn-sm btn-outline-primary"
                        title="View receipt"
                        (click)="viewReceipt(row)">
                    <i class="uil uil-file-download"></i> View
                </button>
            </ng-container>
            <ng-template #noReceiptInRow>--</ng-template>
        </ng-container>
        <ng-container *ngIf="selectedExpense?.expenseId === row.expenseId">
            <ng-container *ngIf="(selectedExpense || row).receiptFileName; else noEditReceipt">
                <img
                        *ngIf="isImageReceipt((selectedExpense || row).receiptFileName, (selectedExpense || row).receiptContentType) && getReceiptThumbnailUrl(selectedExpense || row)"
                        [src]="getReceiptThumbnailUrl(selectedExpense || row)!"
                        alt="Receipt thumbnail"
                        class="receipt-thumb"
                        title="Open receipt"
                        (click)="viewReceipt(selectedExpense || row)"
                />
                <button
                        *ngIf="!isImageReceipt((selectedExpense || row).receiptFileName, (selectedExpense || row).receiptContentType) || !getReceiptThumbnailUrl(selectedExpense || row)"
                        type="button"
                        class="btn btn-sm btn-outline-primary"
                        title="View receipt"
                        (click)="viewReceipt(selectedExpense || row)">
                    <i class="uil uil-file-download"></i> View
                </button>
            </ng-container>
            <ng-template #noEditReceipt>--</ng-template>
        </ng-container>
    </span></ng-template>

    <ng-template #actionsTpl let-row="adtData"><span class="d-inline-block">
        <span *ngIf="status != 'CLOSED'">
        <ng-container *ngIf="selectedExpense?.expenseId !== row.expenseId; else editingButtons">
            <i class="uil uil-edit size-20 text-primary px-1" title="Edit" (click)="editExpense(row)"></i>
            <i class="uil uil-archive size-20 text-danger px-1" title="Delete" (click)="deleteExpense(row.expenseId)"></i>
        </ng-container>
        <ng-template #editingButtons>
            <i class="uil uil-check-circle size-20 text-success px-1" title="Save" (click)="updateExpense()"></i>
            <i class="uil uil-times-circle size-20 text-secondary px-1" title="Cancel" (click)="cancelEdit()"></i>
        </ng-template>
        </span>
    </span></ng-template>

    <!-- Who is owed what: expenses grouped by "Spent By" -->
    <div class="reimb-card mt-4" *ngIf="spenderTotals.length > 0">
        <div class="reimb-head">
            <div>
                <h2 class="rana-panel-title mb-0" style="font-size:18px;">Reimbursements owed</h2>
                <small class="text-muted">What each member spent on this event and is owed back</small>
            </div>
            <div class="reimb-total">
                <span class="text-muted small">Total to repay</span>
                <strong>{{ totalOwedToMembers | currency }}</strong>
            </div>
        </div>
        <div class="reimb-body">
            <svg class="reimb-donut" viewBox="0 0 42 42" role="img" aria-label="Share of reimbursements by person">
                <circle cx="21" cy="21" r="15.9155" fill="none" stroke="#eee" stroke-width="6"></circle>
                <circle *ngFor="let s of spenderTotals; trackBy: trackBySpender" cx="21" cy="21" r="15.9155" fill="none"
                        [attr.stroke]="s.color" stroke-width="6"
                        [attr.stroke-dasharray]="s.percent + ' ' + (100 - s.percent)"
                        [attr.stroke-dashoffset]="s.offset">
                    <title>{{ s.name }}: {{ s.total | currency }} ({{ s.percent | number:'1.0-0' }}%)</title>
                </circle>
            </svg>
            <div class="table-responsive reimb-table">
                <table class="table rana-table mb-0">
                    <thead>
                    <tr>
                        <th>Pay to</th>
                        <th class="text-end">Expenses</th>
                        <th class="text-end">Amount owed</th>
                        <th class="text-end">Share</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let s of spenderTotals; trackBy: trackBySpender">
                        <td>
                            <span class="reimb-dot" [style.background]="s.color"></span>{{ s.name }}
                            <small class="d-block text-muted" *ngIf="s.email">{{ s.email }}</small>
                        </td>
                        <td class="text-end">{{ s.count }}</td>
                        <td class="text-end"><strong>{{ s.total | currency }}</strong></td>
                        <td class="text-end">{{ s.percent | number:'1.0-0' }}%</td>
                    </tr>
                    </tbody>
                    <tfoot>
                    <tr>
                        <td><strong>Total</strong></td>
                        <td></td>
                        <td class="text-end"><strong>{{ totalOwedToMembers | currency }}</strong></td>
                        <td></td>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </div>
        <small class="text-muted d-block mt-2" *ngIf="unassignedTotal > 0">
            Not included: {{ unassignedTotal | currency }} of expenses with no member chosen under Spent By.
        </small>
        <small class="text-muted d-block mt-1">
            Based on the expenses listed above; payments already made back to members are not tracked here.
        </small>
    </div>

    <div *ngIf="!loading && expenses.length === 0" class="text-muted">No expenses found.</div>
</div>
